import { render, staticRenderFns } from "./MainNewsRelease.vue?vue&type=template&id=ea4e65e0&scoped=true&"
import script from "./MainNewsRelease.vue?vue&type=script&lang=js&"
export * from "./MainNewsRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4e65e0",
  null
  
)

export default component.exports